import { pushVoucherRegistrationAnalytics } from "./analytics";
import {
  registerFormSuccessHandler,
  type FormAjaxResponse,
} from "./form";

type VoucherRegistrationResponse = FormAjaxResponse & {
  gaTracking?: Record<string, unknown>;
  targetUrl?: string;
};

function messageElement(className: string, message: string): HTMLParagraphElement {
  const element = document.createElement("p");
  element.className = className;
  element.textContent = message;
  return element;
}

function renderVoucherSuccess(form: HTMLFormElement, targetUrl?: string): void {
  const target = form.querySelector<HTMLElement>("[data-voucher-registration-content]");
  if (!target) {
    return;
  }

  const message = messageElement("text-center", "");
  if (targetUrl) {
    message.textContent = "Viel Spaß auf der Matte (Du wirst nach 4 Sekunden automatisch weitergeleitet).";
  } else {
    const areaLink = document.createElement("a");
    areaLink.href = "/mein-bereich";
    areaLink.title = "Zum Mitglieder-Bereich";
    areaLink.textContent = "Deinem Bereich";
    message.append(
      document.createTextNode("Viel Spaß auf der Matte, hier geht's lang zu "),
      areaLink,
      document.createTextNode(" (Du wirst nach 4 Sekunden automatisch weitergeleitet)."),
    );
  }

  target.replaceChildren(messageElement("success !mb-0 text-center", "Vorgang erfolgreich!"), message);
}

registerFormSuccessHandler("voucher-registration", ({ form, response }) => {
  const voucherResponse = response as VoucherRegistrationResponse;
  renderVoucherSuccess(form, voucherResponse.targetUrl);
  pushVoucherRegistrationAnalytics(voucherResponse);
  window.dispatchEvent(new CustomEvent("voucher:success", { detail: voucherResponse }));
  window.setTimeout(() => {
    window.location.href = voucherResponse.targetUrl || window.location.origin + "/mein-bereich";
  }, 4000);
});
